import {
  Box,
  Button,
  Paper,
  Typography,
  TextField,
  Grid,
  IconButton,
  InputAdornment,
} from "@mui/material";
import { useState, useEffect, useCallback } from "react";
import DeleteIcon from "@mui/icons-material/Delete";
import * as Services from "./../../services/saleng";
import AppBreadcrumbs from "./../../components/AppBreadcrumbs";
import AddIcon from "@mui/icons-material/Add";
import Swal from "sweetalert2";

const StepPrice = () => {
  const [categories, setCategories] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  const sortPricesAsc = (arr = []) =>
    [...(arr || [])].sort((a, b) => (a?.minWeight ?? 0) - (b?.minWeight ?? 0));

  const fetchProducts = useCallback(async () => {
    try {
      const res = await Services.getCategories();
      const cats = res?.data?.data || [];
      setCategories(
        cats.map((cat) => ({
          ...cat,
          prices: sortPricesAsc(cat?.prices || []),
        }))
      );
    } catch (error) {
      console.error("Failed to fetch categories:", error);
    } finally {
      setIsLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchProducts();
  }, [fetchProducts]);

  const handleAddPrice = (categoryId) => {
    setCategories((prev) =>
      prev.map((cat) =>
        cat.id === categoryId
          ? {
              ...cat,
              prices: [
                ...cat.prices,
                { id: Date.now(), minWeight: 0, adjPrice: 0, netPrice: 0 },
              ],
            }
          : cat
      )
    );
  };

  const handleDeletePrice = (categoryId, priceId) => {
    setCategories((prev) =>
      prev.map((cat) =>
        cat.id === categoryId
          ? {
              ...cat,
              prices: cat.prices.filter((p) => p.id !== priceId),
            }
          : cat
      )
    );
  };

  const handleChange = (categoryId, priceId, field, value) => {
    setCategories((prev) =>
      prev.map((cat) =>
        cat.id === categoryId
          ? {
              ...cat,
              prices: cat.prices.map((p) =>
                p.id === priceId ? { ...p, [field]: parseFloat(value) || 0 } : p
              ),
            }
          : cat
      )
    );
  };

  const handleSave = async () => {
    try {
      setIsLoading(true);
      await Services.editCategory2(categories);

      Swal.fire({
        icon: "success",
        title: "บันทึกสำเร็จ",
        showConfirmButton: false,
        timer: 2000,
        customClass: {
          container: "my-swal",
        },
      });

      await fetchProducts();
    } catch (error) {
      console.error("Failed to fetch categories:", error);
      Swal.fire({
        icon: "error",
        title: "เกิดข้อผิดพลาด",
        text: error.response?.data?.message || "ไม่สามารถบันทึกข้อมูลได้",
        showConfirmButton: false,
        timer: 2000,
        customClass: {
          container: "my-swal",
        },
      });
    } finally {
      setIsLoading(false);
    }
  };

  if (isLoading) {
    return <Typography>Loading...</Typography>;
  }

  return (
    <>
      <AppBreadcrumbs />

      <Box sx={{ px: { xs: 2, sm: 3, md: 4 }, py: 2 }}>
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "flex-start",
            flexWrap: "wrap",
            gap: 2,
            my: 2,
          }}
        >
          {/* ส่วนซ้าย: หัวข้อ + Search */}
          <Box
            sx={{
              display: "flex",
              flexDirection: { xs: "column", sm: "row" },
              alignItems: { xs: "stretch", sm: "center" },
              gap: 2,
              flex: 1,
              minWidth: 0,
            }}
          >
            <Typography
              component="h2"
              variant="h5"
              sx={{ whiteSpace: "nowrap" }}
            >
              ราคาขั้นบันไดแบบหมวดหมู่
            </Typography>
          </Box>

          <Box display="flex" gap={1}>
            <Button
              color="success"
              variant="contained"
              onClick={() => handleSave()}
              sx={{ width: 150 }}
            >
              บันทึก
            </Button>
          </Box>
        </Box>

        <Box sx={{ flexGrow: 1 }}>
          <Grid container spacing={2}>
            {categories.map((category) => (
              <Grid item xs={12} sm={12} md={6} lg={4} xl={3} key={category.id}>
                <Paper elevation={3} sx={{ p: 2, borderRadius: 5 }}>
                  <Box
                    display="flex"
                    justifyContent="space-between"
                    alignItems="center"
                  >
                    <Typography variant="h6">{category.name}</Typography>
                    <Button
                      variant="contained"
                      color="inherit"
                      size="small"
                      sx={{ borderRadius: 5 }}
                      onClick={() => handleAddPrice(category.id)}
                    >
                      <AddIcon fontSize="small" /> เพิ่มราคาขั้นบันได
                    </Button>
                  </Box>

                  {console.log("category", category)}
                  {category?.prices &&
                    category.prices.map((price) => (
                      <Box
                        key={price.id}
                        display="flex"
                        alignItems="center"
                        gap={1}
                        my={2}
                      >
                        <TextField
                          size="small"
                          type="number"
                          label="น้ำหนักขั้นต่ำ"
                          value={price.minWeight}
                          onChange={(e) =>
                            handleChange(
                              category.id,
                              price.id,
                              "minWeight",
                              e.target.value
                            )
                          }
                          sx={{ maxWidth: 100 }}
                        />
                        <TextField
                          size="small"
                          type="number"
                          label="เพิ่ม/ลด จากราคาเริ่มต้น"
                          value={price.adjPrice}
                          onChange={(e) =>
                            handleChange(
                              category.id,
                              price.id,
                              "adjPrice",
                              e.target.value
                            )
                          }
                          InputProps={{
                            endAdornment: (
                              <InputAdornment position="end">บาท</InputAdornment>
                            ),
                          }}
                        />

                        <IconButton
                          color="error"
                          onClick={() => handleDeletePrice(category.id, price.id)}
                        >
                          <DeleteIcon />
                        </IconButton>
                      </Box>
                    ))}
                </Paper>
              </Grid>
            ))}
          </Grid>
        </Box>
      </Box>
    </>
  );
};

export default StepPrice;
